/**
 * 시스템 > 모니터링 설정 > Ticket 설정 Store
 *
 * @since 2021-05-24
 * @author wj_tams_dev01
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  api: `${apiPrefix}/ticket-config`,
  ticketList: [], // 티켓 설정 리스트
  ticketCount: 0
})

export const mutations = {
  setTicketList (state, data) {
    state.ticketList = data
    state.ticketCount = state.ticketList.length
  },
  addTicketList (state, data) {
    state.ticketList.push(data)
    state.ticketCount = state.ticketList.length
  }
}

export const actions = {
  // 현재 범위 참조 : dispatch
  // mutation 범위 참조 : commit

  // 티켓 리스트 획득
  async getTicketList ({commit, state}) {
    let msg = ''
    try {
      const {code, result} = await this.$axios.$get(`${state.api}`)
      if (code && code.toLowerCase() === 'ok') {
        commit('setTicketList', result)
        return ''
      }
      msg = result.msg
    } catch (e) {
      msg = e
    }
    return msg
  },
  // 티켓 추가
  async addTicket ({commit, state}, ticketData) {
    let res = {code: 'ok'}
    try {
      const result = await this.$axios.$post(`${state.api}`, ticketData, {successAlert: false, loading: false, headers: { 'Content-Type': 'application/json' }})

      if (result.code === 'ok') {
        commit('addTicketList', result)
      } else {
        res = {code: 'nok', msg: result.result.msg}
      }
    } catch (e) {
      res = {code: 'nok', msg: e}
    }
    return res
  },
  // 티켓 수정
  async updateTicket ({state}, ticketData) {
    let res = {code: 'ok'}
    try {
      const result = await this.$axios.$put(`${state.api}/${ticketData.ticket_config_id}`, ticketData, {successAlert: false, loading: false, headers: { 'Content-Type': 'application/json' }})
      res = result
    } catch (e) {
      res = { code: 'nok', result: {msg: e} }
    }
    return res
  },
  // 티켓 삭제
  async deleteTicket ({state}, ticketID) {
    let res = {code: 'ok'}
    try {
      const result = await this.$axios.$delete(`${state.api}/${ticketID}`, {successAlert: false, loading: false})
      res = result
    } catch (e) {
      res = { code: 'nok', result: {msg: e} }
    }
    return res
  },
  // 티켓 일괄 삭제
  async deleteTickets ({state}, ticketList) {
    let res = {code: 'ok'}
    try {
      const result = await this.$axios.$delete(`${state.api}`, {data: {ticket_config_list: ticketList}}, {successAlert: false, loading: false})
      res = result
    } catch (e) {
      res = { code: 'nok', result: {msg: e} }
    }
    return res
  },
  // 티켓 설정 취소/적용
  async finalCommand ({state}, type) {
    let res = {code: 'ok'}
    const apiUri = `${state.api}/${type}`,
      axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    try {
      const result = await this.$axios.$put(apiUri, void 0, axiosConfig)
      res = result
    } catch (e) {
      res = { code: 'nok', result: {msg: e} }
    }
    return res
  }
}

export const getters = {
}

export const strict = false
